// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

function validateWriteKey(writeKey) {
  const hasSpaces = /\s/.test(writeKey);
  const hasSpecialChars = /[^\w\s-]/.test(writeKey);
  if (hasSpaces && hasSpecialChars) {
    return 'Special characters other than dash and underscore are not allowed. Spaces are not allowed. Please update and retry.';
  }
  if (hasSpaces) {
    return 'Spaces are not allowed. Please update and retry.';
  }
  if (hasSpecialChars) {
    return 'Special characters other than dash and underscore are not allowed. Please update and retry.';
  }
  return null;
}

export default function validatePipelineConfig({ config, existingPipelines, clustersMap }) {
  const errors = [];

  if (!config.name?.trim()) {
    errors.push('Name is required');
  }

  if (!config.writekey?.trim()) {
    errors.push('Writekey is required');
  }

  const hasClusterName = Boolean(config.clusterName);
  const hasClusterId = Boolean(config.clusterId);
  const hasClusterUrl = Boolean(config.clusterUrl);
  const clusterFieldCount = [hasClusterName, hasClusterId, hasClusterUrl].filter(Boolean).length;

  if (clusterFieldCount === 0) {
    errors.push('Must provide one of: clusterName, clusterId, or clusterUrl');
  } else if (clusterFieldCount > 1) {
    errors.push('Must provide only ONE of: clusterName, clusterId, or clusterUrl');
  }

  if (config.writekey) {
    const writKeyError = validateWriteKey(config.writekey);
    if (writKeyError) {
      errors.push(writKeyError);
    }
  }

  if (errors.length > 0) {
    return { valid: false, errors, clusterId: null };
  }

  let cluster = null;

  if (config.clusterName) {
    cluster = clustersMap.byName[config.clusterName];
    if (!cluster) {
      errors.push(`Cluster '${config.clusterName}' not found`);
    }
  } else if (config.clusterId) {
    cluster = clustersMap.byId[config.clusterId];
    if (!cluster) {
      errors.push(`Cluster with ID '${config.clusterId}' not found`);
    }
  } else if (config.clusterUrl) {
    const matchingClusters = clustersMap.byUrl[config.clusterUrl] || [];
    if (matchingClusters.length === 0) {
      errors.push(`Cluster with URL '${config.clusterUrl}' not found`);
    } else if (matchingClusters.length > 1) {
      errors.push(
        `Multiple clusters found with URL '${config.clusterUrl}'. Please use clusterId or clusterName instead.`
      );
    } else {
      cluster = matchingClusters[0];
    }
  }

  if (!cluster) {
    return { valid: false, errors, clusterId: null };
  }

  if (existingPipelines.some(pipeline => pipeline.name === config.name)) {
    errors.push(`Pipeline with name '${config.name}' already exists`);
  }

  if (existingPipelines.some(pipeline => pipeline.writekey === config.writekey && pipeline.clusterId === cluster.id)) {
    errors.push(
      `A pipeline connected to the '${cluster.name}' cluster already contains this writekey. Pipeline writekeys must be unique within each cluster.`
    );
  }

  return {
    valid: errors.length === 0,
    errors,
    clusterId: cluster?.id || null,
    cluster,
  };
}
